
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/account/referral",
      function () {
        return require("private-next-pages/account/referral/index.p.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/account/referral"])
      });
    }
  